import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { StepIndicator } from '../../components/StepIndicator';
import { CheckCircleIcon, PackageIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Select Product', 'Background', 'Greetings', 'Store Info', 'Generate', 'Output Format'];
const PRODUCTS = [{
  id: 1,
  name: 'Fashion Product 1',
  category: 'Fashion'
}, {
  id: 2,
  name: 'Fashion Product 2',
  category: 'Fashion'
}, {
  id: 3,
  name: 'Fashion Product 3',
  category: 'Fashion'
}, {
  id: 4,
  name: 'Fashion Product 4',
  category: 'Fashion'
}, {
  id: 5,
  name: 'Fashion Product 5',
  category: 'Fashion'
}, {
  id: 6,
  name: 'Fashion Product 6',
  category: 'Fashion'
}, {
  id: 7,
  name: 'Fashion Product 7',
  category: 'Fashion'
}, {
  id: 8,
  name: 'Fashion Product 8',
  category: 'Fashion'
}];
export function SelectCarModel() {
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState<number | null>(null);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2735">
      <Sidebar data-id="element-2736" />
      <main className="flex-1" data-id="element-2737">
        <Header data-id="element-2738" />
        <StepIndicator currentStep={1} steps={STEPS} data-id="element-2739" />
        <div className="px-6 py-8" data-id="element-2740">
          <div className="max-w-5xl mx-auto" data-id="element-2741">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2742">
              Step 1: Select Product
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-2743">
              Choose a brand-approved product for your creative
            </p>

            <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-2744">
              <h3 className="font-medium text-gray-800 mb-4" data-id="element-2745">
                Available Products
              </h3>

              <div className="grid grid-cols-4 gap-4" data-id="element-2746">
                {PRODUCTS.map(model => <button key={model.id} onClick={() => setSelectedModel(model.id)} className={`p-4 rounded-lg border-2 transition-all ${selectedModel === model.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-2747">
                    <div className="w-full h-32 bg-gray-100 rounded-lg mb-3 flex items-center justify-center" data-id="element-2748">
                      <PackageIcon className="text-gray-400" size={48} data-id="element-2749" />
                    </div>
                    <div className="flex items-center justify-between mb-1" data-id="element-2750">
                      <span className="font-medium text-gray-800 text-sm" data-id="element-2751">
                        {model.name}
                      </span>
                      {selectedModel === model.id && <CheckCircleIcon className="text-blue-500 flex-shrink-0" size={20} data-id="element-2752" />}
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-2753">
                      {model.category}
                    </span>
                  </button>)}
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6" data-id="element-2754">
              <h4 className="font-medium text-blue-900 mb-2" data-id="element-2755">
                Brand-Approved Images
              </h4>
              <p className="text-sm text-blue-800" data-id="element-2756">
                All product images are pre-approved by the brand with clean
                backgrounds, ready for customization
              </p>
            </div>

            <div className="flex justify-between" data-id="element-2757">
              <button onClick={() => navigate('/creative-customizer')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-2758">
                Cancel
              </button>
              <button onClick={() => navigate('/dealer/ai-generator/step-2')} disabled={!selectedModel} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors" data-id="element-2759">
                Continue to Background
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}